import opportunitiesImage from '../assets/images/Opportunities1.svg'
import Button from './Button';
import Counter from './features/Counter';
import { motion } from "framer-motion";
import { useEffect, useState } from 'react';

const Opportunities = () => {
    const [protocolData, setProtocolData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchProtocolData = async () => {
            setIsLoading(true);
            try {
                const response = await fetch('https://api.mondrianswap.xyz/graphql', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        query: `
                            query {
                                embrGetProtocolData {
                                    embrPrice
                                    circulatingSupply
                                    totalLiquidity
                                }
                            }
                        `
                    })
                });

                const data = await response.json();
                
                if (data.data?.embrGetProtocolData) {
                    const protocolData = data.data.embrGetProtocolData;
                    // Parse the values immediately
                    setProtocolData({
                        embrPrice: parseFloat(protocolData.embrPrice),
                        circulatingSupply: parseFloat(protocolData.circulatingSupply),
                        totalLiquidity: parseFloat(protocolData.totalLiquidity)
                    });
                }
            } catch (error) {
                console.error('Error fetching protocol data:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchProtocolData();
    }, []);

    const formatNumber = (value, decimals = 0) => {
        if (isLoading) return decimals > 0 ? '0.000' : '0';
        if (value === null || value === undefined) return decimals > 0 ? '0.000' : '0';
        const num = typeof value === 'string' ? parseFloat(value) : value;
        if (isNaN(num)) return decimals > 0 ? '0.000' : '0';
        return num.toFixed(decimals);
    };

    console.log("Current Protocol Data State:", protocolData);

    const animation = (delay, xStart, xEnd, yStart, yEnd) => {
        const result = {
            initial: { opacity: 0, x: xStart, y: yStart },
            whileInView: { opacity: 1, x: xEnd, y: yEnd },
            viewport: { once: true },
            transition: {
                ease: "easeInOut",
                duration: 0.6,
                delay: delay,
            }
        }
        return result;
    }
    const opportunities = [
        {
            value: protocolData ? formatNumber(protocolData.totalLiquidity) : '0',
            text: 'Total Value Locked',
            pointColor: '#F56262'
        },
        {
            value: protocolData ? formatNumber(protocolData.embrPrice, 3) : '0.000',
            text: '$Mond Price',
            pointColor: '#F56262',
            isPrice: true,
            startValue: 0.000
        },
        {
            value: protocolData ? formatNumber(protocolData.circulatingSupply) : '0',
            text: '$Mond Circulating Supply',
            pointColor: '#02B9FF'
        },
    ]

    console.log("Opportunities Array:", opportunities);

    return (
        <>
            <div className='absolute -z-10 w-full h-screen sm:h-full md:h-screen' style={{ width: '-webkit-fill-available' }}>
                <img 
                    src={opportunitiesImage} 
                    className="w-full h-full object-cover sm:h-[200%] md:h-full"
                    style={{
                        maxHeight: '100vh',
                        minHeight: '100%'
                    }}
                    alt="Opportunities background"
                />
            </div>
            {/* <div className="bg-[#334756] w-1/2 flex h-80 corner_bottom -mb-[2px]"></div> */}
            <div className='px-[5%]'>
                <div className='mt-[200px] xl:mt-36 flex flex-row sm:flex-col md:flex-row md:items-end md:justify-between gap-6 md:gap-0'>
                    <motion.div {...animation(0.4, -150, 0, 0, 0)} className='text-5xl sm:text-6xl xl:text-6xl uppercase font-bold font-inherit'>
                        mondrian<br /> statistics
                    </motion.div>
                    <motion.div {...animation(0.4, 150, 0, 0, 0)}>
                        <Button text={'ANALYTICS'} />
                    </motion.div>
                </div>
                <div className='flex flex-row sm:flex-col md:flex-row justify-between sm:gap-0 md:gap-0 mt-16 sm:mt-4 md:mt-32'>
                    {opportunities.map((el, i) => (
                        <motion.div 
                            {...animation(0.4, 0, 0, 150, 0)} 
                            className='w-[31%] sm:w-full md:w-[31%] rounded-[30px] p-[56px_24px] sm:p-[32px_24px] md:p-[56px_24px] flex flex-col items-center gap-[16px] transition-all duration-300 hover:cursor-pointer'
                            style={{
                                background: 'rgba(220, 238, 246, 0.05)',
                                border: '2px solid var(--light-20, rgba(255, 255, 255, 0.2)'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = 'linear-gradient(249deg, #00E499 3.36%, #004A2E 98.6%)';
                                e.currentTarget.style.border = '2px solid #64F9C8';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = 'rgba(220, 238, 246, 0.05)';
                                e.currentTarget.style.border = '2px solid var(--light-20, rgba(255, 255, 255, 0.2)';
                            }}
                        >
                            <div className='font-inherit text-[64px] sm:text-4xl md:text-[64px] leading-none font-normal flex items-center gap-3' style={{ fontWeight: el.value === 'NaN' ? '700' : '' }}>
                                <span className={`block rounded-full w-[12px] h-[12px]`} style={{ background: el.pointColor }}></span>
                                {el.pointColor === '#F56262' ? '$' : ''}
                                <Counter 
                                    value={isLoading ? 0 : parseFloat(el.value) || 0} 
                                    start={el.startValue || 0}
                                    duration={2}
                                    decimals={el.isPrice ? 3 : 0}
                                    isPrice={el.isPrice}
                                />
                                {el.pointColor === '#F56262' ? '' : ''}
                            </div>
                            <div className='font-inherit text-2xl sm:text-xl md:text-2xl text-[#BABABA] font-normal text-center'>{el.text}</div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </>
    );
};
export default Opportunities;